export default __webpack_public_path__ + "static/media/Sprite.52b9c083.svg";